import { useEffect } from "react";
import { useKeyPress } from './useKeyPress';

interface ArrowNavigationProps {
  onUp(): void;
  onDown(): void;
  onLeft(): void;
  onRight(): void;
}

export const useArrowNavigation = ({ onDown, onLeft, onRight, onUp }: ArrowNavigationProps) => {
  const arrowUp = useKeyPress('ArrowUp');
  const arrowLeft = useKeyPress('ArrowLeft');
  const arrowDown = useKeyPress('ArrowDown');
  const arrowRight = useKeyPress('ArrowRight');

  useEffect(() => {
    if (arrowUp) {
      onUp();
    }
  }, [arrowUp, onUp]);

  useEffect(() => {
    if (arrowLeft) {
      onLeft();
    }
  }, [arrowLeft, onLeft]);

  useEffect(() => {
    if (arrowDown) {
      onDown();
    }
  }, [arrowDown, onDown]);

  useEffect(() => {
    if (arrowRight) {
      onRight();
    }
  }, [arrowRight, onRight]);
}
